import { Badge, Flex } from 'components'
import { IEvaluationTool } from 'interfaces'

interface ProjectEvaluationToolsProps {
  tools: IEvaluationTool[]
}

/**
 * Renders evaluation tools as badges
 */
export const ProjectEvaluationTools = ({ tools }: ProjectEvaluationToolsProps) => (
  <Flex direction='row' wrap='wrap'>
    {tools.map((tool: IEvaluationTool) => (
      <Badge key={tool.id} color='indigo.6' size='md' variant='filled' mr='sm' mt='sm'>
        {tool.name}
      </Badge>
    ))}
  </Flex>
)
